import { render } from "./Carousel.vue?vue&type=template&id=0a97d122"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=0a97d122&lang=scss"

import exportComponent from "D:\\Nerd\\RumbleFish\\Website\\Code\\rumblefish\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__